import { combineReducers } from '@reduxjs/toolkit';
import abs from './abs';
import i18n from './i18nSlice';
import user from './userSlice';
import login from './loginSlice';
import abshelper from './helperSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    abs,
    i18n,
    user,
    login,
    abshelper,
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === 'user/userLoggedOut') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
